import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './App.css';
import { Provider } from 'react-redux';
import store from './redux/store/Index';
import { Login } from './views/pages/Index';
import DefaultLayout from './container/defaultLayout/DefaultLayout'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    return (
        <Provider store={store}>
          <HashRouter>
            <Switch>
              <Route exact path="/" name="Login Page" component={Login} />
              <Route exact path="/login" name="Login Page" component={Login} />
              <Route path='/' component={DefaultLayout} /> 
            </Switch>
          </HashRouter>
        </Provider>
    );
  }
}

export default App;